import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function NativeAiMl() {
  return <DetailPage data={detailPages["native-ai-ml"]} />;
}
